import { Box, Typography, Button } from '@mui/material'
import React from 'react'
import verify from '../../assets/Icons/verify 1.svg'
import { Link } from 'react-router-dom';
import LottieWrapper from '../Common/LottieWrapper';
import anime from "../../assets/anime/ordered.json"
import ConfettiExplosion from 'react-confetti-explosion';

const Confirmation = () => {
  return (
    <>
      <Box sx={{ display: "grid", placeItems: "center", height: "300px" }}>
        <Box align="center">
        <ConfettiExplosion
              duration={6000}
              zIndex={10000}
              particleSize={7}
              colors={["#EBDCEF", "#7B408C", "#1F1023", "#FFCD29", "#FFF9E5"]}
            />
       <LottieWrapper animationData={anime}/>
          <Typography
            sx={{ fontSize: "20px", color: "#1a1a1a", fontWeight: 500 }}
          >
            Order Successful
          </Typography>
          <Typography sx={{ color: "#1a1a1a", fontSize: "13px" }}>
            Your order has been placed, ID: F587553RRF
          </Typography>
          <Link to="/">
            <Button variant="contained" sx={{ mt: 3, borderRadius: "100px" }}>
        Continue shopping
            </Button>
          </Link>
          <Link to="/account/orders">
            <Button  variant="outlined" sx={{ mt: 3, borderRadius: "100px", ml:{lg:3, md:3, sm:0,xs:0} }}>
            Track your orders
            </Button>
          </Link>
        </Box>
      </Box>
    </>
  );
}

export default Confirmation
